// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2R9bq","requiredAsterisk":"Info_requiredAsterisk__1mKsN"};